import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { updateMap } from '../services/mapServices'

export function useMapUpdate() {
  const queryClient = useQueryClient()

  const {
    mutate: mapUpdate,
    isLoading: isLoadingMapUpdate,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: updateMap,
  })

  useEffect(() => {
    if (isSuccess) {
      queryClient.removeQueries({ queryKey: ['mapsList'] })
      queryClient.removeQueries({ queryKey: ['Map'] })
      queryClient.removeQueries({ queryKey: ['section'] })
      queryClient.removeQueries({ queryKey: ['dynamic-motions'] })
    }
  }, [isSuccess, queryClient])

  return {
    mapUpdate,
    isLoadingMapUpdate,
    error,
    isSuccessMapUpdate: isSuccess,
  }
}